module.exports = __webpack_public_path__ + "static/img/new-home-item1.d71a2e3e.jpg";